module.exports = __webpack_public_path__ + "static/media/014.b295ceb7.jpg";